/**
 * A machine view's frame on the workbench page: the machine's `ViewHeader` sits above every view, so a view opens
 * with one quiet line (its title, what it is for, its actions at the far end), then the view. `fill` is for a view
 * that fills its frame and scrolls inside itself (the task board, the screen, a terminal); otherwise the page scrolls.
 */

import type { ReactNode } from 'react';

import { useViewMeta } from '../viewMeta.ts';

export function ViewTitle({ actions }: { actions?: ReactNode }) {
  const m = useViewMeta();
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2" data-tone={m.tone}>
      <div className="min-w-0 flex-1 basis-72">
        <h2 className="m-0 text-base font-semibold">{m.title}</h2>
        <p className="m-0 text-sm text-muted">{m.subtitle}</p>
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function RemoteView({ actions, children, fill, narrow }: { actions?: ReactNode; children: ReactNode; fill?: boolean; narrow?: boolean }) {
  if (fill) {
    return (
      <div className="flex h-full min-h-0 flex-col gap-3">
        <ViewTitle actions={actions} />
        {children}
      </div>
    );
  }
  return (
    <div className={`flex w-full min-w-0 flex-col gap-4 ${narrow ? 'max-w-4xl' : ''}`}>
      <ViewTitle actions={actions} />
      {children}
    </div>
  );
}
